import React from 'react';

const AccountDetailsStep = ({ 
    formData, 
    setFormData, 
    venueKey, 
    emailValidationText, 
    passwordValidationText 
}) => {
    return (
        <div className="space-y-4">
            <div>
                <label htmlFor="venueKey" className="block text-sm font-medium text-gray-300 mb-2">
                    Venue Key
                </label>
                <input
                    id="venueKey"
                    type="text"
                    value={venueKey}
                    disabled
                    className="input-field bg-gray-600 text-gray-400"
                    placeholder="Venue key will be populated automatically"
                />
            </div>

            <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2">
                    Email Address *
                </label>
                <input
                    id="email"
                    type="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    className="input-field"
                    placeholder="Enter your email address"
                />
                {emailValidationText && (
                    <p className="mt-1 text-sm text-red-400">{emailValidationText}</p>
                )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label htmlFor="firstName" className="block text-sm font-medium text-gray-300 mb-2">
                        First Name
                    </label>
                    <input
                        id="firstName"
                        type="text"
                        value={formData.firstName}
                        onChange={(e) => setFormData({...formData, firstName: e.target.value})}
                        className="input-field"
                        placeholder="Enter your first name"
                    />
                </div>

                <div>
                    <label htmlFor="surname" className="block text-sm font-medium text-gray-300 mb-2">
                        Surname
                    </label>
                    <input
                        id="surname"
                        type="text"
                        value={formData.surname}
                        onChange={(e) => setFormData({...formData, surname: e.target.value})}
                        className="input-field"
                        placeholder="Enter your surname"
                    />
                </div>
            </div>

            <div>
                <label htmlFor="pwd" className="block text-sm font-medium text-gray-300 mb-2">
                    Password *
                </label>
                <input
                    id="pwd"
                    type="password"
                    required
                    value={formData.password}
                    onChange={(e) => setFormData({...formData, password: e.target.value})}
                    className="input-field"
                    placeholder="Enter your password (minimum 8 characters)"
                />
            </div>

            <div>
                <label htmlFor="confirmPwd" className="block text-sm font-medium text-gray-300 mb-2">
                    Confirm Password *
                </label>
                <input
                    id="confirmPwd"
                    type="password"
                    required
                    value={formData.confirmPassword}
                    onChange={(e) => setFormData({...formData, confirmPassword: e.target.value})}
                    className="input-field"
                    placeholder="Confirm your password"
                />
                {passwordValidationText && (
                    <p className="mt-1 text-sm text-red-400">{passwordValidationText}</p>
                )}
            </div>
        </div>
    );
};

export default AccountDetailsStep;
